module.exports = __webpack_public_path__ + "media/icon/icon-map-area-e33081c5.svg";